import { ChangeDetectionStrategy, Component, computed, effect, inject, input, OnInit, signal } from '@angular/core';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger, kutukGeo } from '@/src/app/shared/utils/param-deger.utils';
import { StraforKesiciService } from '@/src/app/uygulamalar/strafor-kesici/services/strafor-kesici.service';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';

const DURUMLAR = [
  { isim: 'Bekliyor', renk: '#94a3b8', ikon: '⏳' },
  { isim: 'Görüldü', renk: '#3b82f6', ikon: '👁️' },
  { isim: 'Hazırlanıyor', renk: '#f59e0b', ikon: '🔨' },
  { isim: 'Tamamlandı', renk: '#22c55e', ikon: '✅' },
  { isim: 'İptal', renk: '#ef4444', ikon: '❌' },
];

const DURUM_SETI = {
  id: 'cam.kutuk.durum', baslik: 'Durum Güncelleme', simge: '🔄', kaynak: 'kod',
  parametreler: [
    { turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: { zorunlu: true, secenekler: [
      { label: 'Bekliyor', value: 'Bekliyor' }, { label: 'Görüldü', value: 'Görüldü' },
      { label: 'Hazırlanıyor', value: 'Hazırlanıyor' }, { label: 'Tamamlandı', value: 'Tamamlandı' },
      { label: 'İptal', value: 'İptal' },
    ] } },
    { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
  ],
};

@Component({
  selector: 'cam-kutuk-kart-sade',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="kk">
      @if (d('kutukId') || d('projeAdi')) {
      <div class="kk-ust">
        @if (d('kutukId')) { <span class="kk-id">{{ d('kutukId') }}</span> }
        @if (d('projeAdi')) { <span class="kk-proje">{{ d('projeAdi') }}</span> }
      </div>
      }
      <div class="kk-gorsel">
        <svg [attr.viewBox]="g().vb" preserveAspectRatio="xMidYMid meet" class="kk-svg">
          <defs>
            <linearGradient id="skU" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#fbbf24"/><stop offset="100%" stop-color="#f59e0b"/></linearGradient>
            <linearGradient id="skO" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#d97706"/><stop offset="100%" stop-color="#b45309"/></linearGradient>
            <linearGradient id="skS" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#b45309"/><stop offset="100%" stop-color="#92400e"/></linearGradient>
            <filter id="skSh"><feDropShadow dx="1" dy="2" stdDeviation="2" flood-color="#000" flood-opacity=".12"/></filter>
            <marker id="aB" viewBox="0 0 8 8" refX="4" refY="4" markerWidth="4" markerHeight="4" orient="auto-start-reverse"><path d="M1,1 L7,4 L1,7Z" fill="#3b82f6"/></marker>
            <marker id="aG" viewBox="0 0 8 8" refX="4" refY="4" markerWidth="4" markerHeight="4" orient="auto-start-reverse"><path d="M1,1 L7,4 L1,7Z" fill="#22c55e"/></marker>
            <marker id="aR" viewBox="0 0 8 8" refX="4" refY="4" markerWidth="4" markerHeight="4" orient="auto-start-reverse"><path d="M1,1 L7,4 L1,7Z" fill="#ef4444"/></marker>
          </defs>
          <pattern id="skGr" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M 20 0 L 0 0 0 20" fill="none" stroke="var(--py-kenarlik,#e5e7eb)" stroke-width=".3" opacity=".4"/></pattern>
          <rect width="100%" height="100%" fill="url(#skGr)"/>
          <g filter="url(#skSh)">
            <polygon [attr.points]="g().on" fill="url(#skO)"/>
            <polygon [attr.points]="g().sag" fill="url(#skS)"/>
            <polygon [attr.points]="g().ust" fill="url(#skU)"/>
          </g>
          <polygon [attr.points]="g().on" fill="none" stroke="#92400e" stroke-width="1" stroke-linejoin="round"/>
          <polygon [attr.points]="g().sag" fill="none" stroke="#78350f" stroke-width="1" stroke-linejoin="round"/>
          <polygon [attr.points]="g().ust" fill="none" stroke="#a16207" stroke-width="1" stroke-linejoin="round"/>
          <g [attr.transform]="'translate(0,' + (g().by + 18) + ')'">
            <line [attr.x1]="g().bx" y1="0" [attr.x2]="g().bx + g().w" y2="0" stroke="#3b82f6" stroke-width="1.5" marker-start="url(#aB)" marker-end="url(#aB)"/>
            <rect [attr.x]="g().bx + g().w/2 - 26" y="-7" width="52" height="14" rx="3" fill="var(--py-arkaplan,#fff)" stroke="#3b82f6" stroke-width=".5" opacity=".9"/>
            <text [attr.x]="g().bx + g().w/2" y="4" text-anchor="middle" fill="#3b82f6" font-size="9" font-weight="700" font-family="'Consolas',monospace">{{ g().enD }}</text>
          </g>
          <g [attr.transform]="'translate(' + (g().bx - 18) + ',0)'">
            <line x1="0" [attr.y1]="g().by" x2="0" [attr.y2]="g().by - g().h" stroke="#ef4444" stroke-width="1.5" marker-start="url(#aR)" marker-end="url(#aR)"/>
            <rect x="-30" [attr.y]="g().by - g().h/2 - 7" width="52" height="14" rx="3" fill="var(--py-arkaplan,#fff)" stroke="#ef4444" stroke-width=".5" opacity=".9"/>
            <text x="-4" [attr.y]="g().by - g().h/2 + 4" text-anchor="middle" fill="#ef4444" font-size="9" font-weight="700" font-family="'Consolas',monospace">{{ g().yukD }}</text>
          </g>
          <line [attr.x1]="g().bx + g().w + 18" [attr.y1]="g().by" [attr.x2]="g().bx + g().w + g().dh + 18" [attr.y2]="g().by - g().dh" stroke="#22c55e" stroke-width="1.5" marker-start="url(#aG)" marker-end="url(#aG)"/>
          <rect [attr.x]="g().bx + g().w + g().dh*.5 + 22" [attr.y]="g().by - g().dh*.5 - 7" width="52" height="14" rx="3" fill="var(--py-arkaplan,#fff)" stroke="#22c55e" stroke-width=".5" opacity=".9"/>
          <text [attr.x]="g().bx + g().w + g().dh*.5 + 48" [attr.y]="g().by - g().dh*.5 + 4" text-anchor="middle" fill="#22c55e" font-size="9" font-weight="700" font-family="'Consolas',monospace">{{ g().boyD }}</text>
          <text [attr.x]="g().mx" y="14" text-anchor="middle" fill="var(--py-metin-ucuncul,#94a3b8)" font-size="8" font-weight="600" letter-spacing="2" font-family="system-ui">KÜTÜK ÖLÇÜLERİ</text>
        </svg>
      </div>

      <div class="kk-bilgi">
        <div class="kk-satir">
          <div class="kk-alan"><span class="kk-etiket">En</span><span class="kk-deger kk-x">{{ d('en') || '—' }} <small>mm</small></span></div>
          <div class="kk-alan"><span class="kk-etiket">Boy</span><span class="kk-deger kk-y">{{ d('boy') || '—' }} <small>mm</small></span></div>
          <div class="kk-alan"><span class="kk-etiket">Yükseklik</span><span class="kk-deger kk-z">{{ d('yukseklik') || '—' }} <small>mm</small></span></div>
          @if (d('adet')) { <div class="kk-alan"><span class="kk-etiket">Adet</span><span class="kk-deger">{{ d('adet') }}</span></div> }
        </div>

        <div class="kk-durum-bar">
          @for (dr of durumlar; track dr.isim) {
            <button class="kk-durum-btn"
              [class.kk-durum-aktif]="sonDurum() === dr.isim"
              [style.--dr]="dr.renk"
              [disabled]="durumKaydediliyor()"
              (click)="durumDegistir(dr.isim)">
              <span>{{ dr.ikon }}</span>
              <span>{{ dr.isim }}</span>
            </button>
          }
        </div>

        @if (d('notlar')) { <div class="kk-not">{{ d('notlar') }}</div> }
        @if (d('en') && d('boy') && d('yukseklik')) {
        <button class="kk-kesici-btn" (click)="straforKesiciyeGit()">
          <span>✂️</span><span>Strafor Kesiciye Gönder</span>
          <span class="kk-kesici-olcu">{{ d('en') }}×{{ d('boy') }}×{{ d('yukseklik') }}</span>
        </button>
        }
      </div>
    </div>
  `,
  styles: [`
    .kk { display:flex; flex-direction:column; }
    .kk-ust { display:flex; gap:8px; align-items:center; padding:0 0 4px; }
    .kk-id { font-size:13px; font-weight:700; color:var(--py-metin,#333); font-family:'Consolas',monospace; }
    .kk-proje { font-size:12px; color:var(--py-metin-ikincil,#666); }
    .kk-gorsel { border-radius:8px; overflow:hidden; border:1px solid var(--py-kenarlik,#f0f0f0); background:var(--py-arkaplan,#fff); }
    .kk-svg { display:block; width:100%; }
    .kk-bilgi { padding:8px 0 0; }
    .kk-satir { display:flex; gap:0; }
    .kk-alan { display:flex; flex-direction:column; gap:1px; flex:1; }
    .kk-etiket { font-size:10px; font-weight:600; color:var(--py-metin-ucuncul,rgba(0,0,0,.4)); text-transform:uppercase; letter-spacing:.5px; }
    .kk-deger { font-size:14px; font-weight:700; color:var(--py-metin,#333); font-family:'Consolas',monospace; small { font-size:10px; font-weight:400; color:var(--py-metin-ucuncul,#999); } }
    .kk-x { color:#3b82f6; }
    .kk-y { color:#22c55e; }
    .kk-z { color:#ef4444; }
    .kk-durum-bar { display:flex; gap:4px; margin-top:8px; flex-wrap:wrap; }
    .kk-durum-btn { display:flex; align-items:center; gap:3px; padding:4px 8px; border:1px solid var(--py-kenarlik,#e5e7eb); border-radius:6px; background:transparent; cursor:pointer; font-size:11px; font-weight:500; color:var(--py-metin-ikincil,#666); transition:all .15s;
      &:hover { border-color:var(--dr); color:var(--dr); background:color-mix(in srgb, var(--dr) 8%, transparent); }
    }
    .kk-durum-aktif { border-color:var(--dr) !important; color:var(--dr) !important; background:color-mix(in srgb, var(--dr) 12%, transparent) !important; font-weight:700; }
    .kk-not { margin-top:6px; padding:6px 8px; font-size:12px; color:var(--py-metin-ikincil,#666); background:var(--py-arkaplan-soluk,rgba(0,0,0,.02)); border-radius:6px; line-height:1.4; }
    .kk-kesici-btn { display:flex; align-items:center; gap:6px; width:100%; margin-top:6px; padding:6px 10px; border:1px dashed var(--py-kenarlik,#d9d9d9); border-radius:6px; background:transparent; cursor:pointer; font-size:12px; font-weight:600; color:var(--py-metin,#333); transition:all .2s;
      &:hover { border-color:var(--py-link,#1890ff); background:rgba(24,144,255,.04); }
    }
    .kk-kesici-olcu { margin-left:auto; font-size:10px; font-family:monospace; color:var(--py-metin-ucuncul,#999); }
  `],
})
export class CamKutukKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  private strafor = inject(StraforKesiciService);
  durumlar = DURUMLAR;
  durumKaydediliyor = signal(false);

  /** Yerel kart kopyası (mutation için reactive signal) */
  kartObj = signal<any>(null);

  constructor() {
    super();
    // parametreler input'u değişince kart objesini yerel signal'e kopyala
    effect(() => {
      const kart = this.parametreler()?.kart;
      this.kartObj.set(kart || null);
    });
    // Eğer prepipe'tan _hesap.sonDurum gelmediyse DB'den çek
    effect(() => {
      const k = this.kartObj();
      if (k?._id && !k?._hesap?.sonDurum) {
        this.sonDurumCek(k._id);
      }
    });
  }

  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
  g = computed(() => kutukGeo(+(this.d('en') || 0), +(this.d('boy') || 0), +(this.d('yukseklik') || 0)));

  sonDurum = computed(() => {
    const k = this.kartObj();
    return k?._hesap?.sonDurum || this.d('durum') || 'Bekliyor';
  });

  /** Prepipe'tan veri gelmediyse fallback olarak DB'den taze çek */
  private async sonDurumCek(kartId: string) {
    try {
      const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.aggregate' });
      istek.parametreler = { aggregate: [
        { $match: { _uid: kartId, silindi: { $ne: true }, turu: 'KART' } },
        { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'ic' } },
        { $unwind: { path: '$ic', preserveNullAndEmptyArrays: false } },
        { $match: { 'ic.ek._secilenSetId': 'cam.kutuk.durum' } },
        { $sort: { _id: -1 } },
        { $limit: 1 },
        { $project: { 'ic.ek.durum': 1 } },
      ] };
      const cevap: any = await istek.isteSync();
      const durum = cevap?.cevap?.sonuc?.[0]?.ic?.ek?.durum;
      if (durum) {
        this._kartHesapGuncelle({ sonDurum: durum });
      }
    } catch {}
  }

  /** Yerel kart objesinin _hesap alanını günceller (yeni reference ile reactive) */
  private _kartHesapGuncelle(yenilenenler: any) {
    const k = this.kartObj();
    if (!k) return;
    this.kartObj.set({
      ...k,
      _hesap: { ...(k._hesap || {}), ...yenilenenler },
    });
  }

  private ekleIstek = new FikoYTIstekKok({
    metod: 'POST', komut: 'FikoYT.sistem.DB.hareketler.ekle',
    onEkOlsun: true, depoModu: false, oncelik: 0, gecikmeliCevap: false,
  });

  async durumDegistir(yeniDurum: string) {
    if (this.sonDurum() === yeniDurum || this.durumKaydediliyor()) return;
    const kartId = this.parametreler()?.kart?._id;
    if (!kartId) return;

    this.durumKaydediliyor.set(true);
    try {
      const kartKimlik = this.FikoYT.fikoIdUret();
      const icerikKimlik = this.FikoYT.fikoIdUret();
      const sahip = this.FikoYT.kimlik.aktifKullaniciJson()?._id;

      const kart: any = {
        _id: kartKimlik,
        vt: 'FikoYT.sistem.hareketler',
        yol: 'FikoYT.sistem.hareketler.kalem',
        turu: 'KART',
        gizlilik: 'Herkese Açık',
        _uid: kartId,
        sahip,
        tarih: new Date(),
        veri: {
          solSimge: { baslik: '🔄', renkArka: '#92400e', renkYazi: '#fff' },
          icerikler: [icerikKimlik],
        },
      };

      const icerik: any = {
        _id: icerikKimlik,
        _uid: kartKimlik,
        html: '', aciklama: '', sifre: null,
        ek: {
          turu: 'UYGULAMAICERIK',
          _secilenSetId: 'cam.kutuk.durum',
          bilesen: 'cam-kutuk-durum',
          durum: yeniDurum,
        },
      };

      const fd1 = new FormData();
      fd1.append('req_body', JSON.stringify(kart));
      this.ekleIstek.parametreler = fd1;
      await this.ekleIstek.isteSync();

      const fd2 = new FormData();
      fd2.append('req_body', JSON.stringify(icerik));
      this.ekleIstek.parametreler = fd2;
      await this.ekleIstek.isteSync();

      // Yerel kart objesini güncelle (UI anında değişsin)
      this._kartHesapGuncelle({ sonDurum: yeniDurum });
      this.nzMessage.success(`Durum: ${yeniDurum}`);
    } catch {
      this.nzMessage.error('Durum güncellenemedi');
    } finally {
      this.durumKaydediliyor.set(false);
    }
  }

  straforKesiciyeGit() {
    const en = +this.d('en'), boy = +this.d('boy'), yuk = +this.d('yukseklik');
    if (!en || !boy || !yuk) return;
    this.strafor.hedefParca.set({ en, boy, yukseklik: yuk });
    this.router.navigate(['/🧩/✂️/kesim-plani']);
  }
}
